export default {
  oauthStratumn: {
    '& > *': {
      margin: '0 8px 8px'
    }
  },
  stratumnTriangle: {
    height: 16,
    filter: 'brightness(0) invert(1)'
  }
};
